import { statusColorObj } from '../themes';

export default {
  on: statusColorObj.on,
  normal: statusColorObj.normal,
  warning: statusColorObj.warning,
  danger: statusColorObj.danger,
};
